skrilla.directive('userVerificationDetails', function (modalService, searchService) {
    return {
        templateUrl: 'directives/userVerifications/userVerificationDetails.html',
        scope: {
            verification: "=",
        },
        controller: function ($scope) {
            $scope.dataSourceTableData = {
                columns: [
                    {title: "Method", field: "method"},
                    {title: "Status", field: "status"},
                    {title: "Type", field: "type"},
                    {title: "Name", field: "name"},
                ],
                rows: {orderBy: "-createdAt", style: "cursor: pointer;"},
                isSkrillaTable: true,
                data: $scope.verification ? $scope.verification.dataSources : []
            }

            $scope.calculateSourcesRequired = (verification) => {
                if (verification.status === 'VERIFIED' || verification.status === 'VERIFIED_ADMIN') {
                    return 0;
                }
                if (verification.dataSources.some(it => it.sufficient && (it.status !== 'VERIFIED' && it.status !== 'VERIFIED_ADMIN'))) {
                    return 1
                }
                return 2
            }

            $scope.sourcesRequired = $scope.calculateSourcesRequired($scope.verification)

            $scope.$watch('verification', function () {
                $scope.dataSourceTableData.data = $scope.verification ? $scope.verification.dataSources : []
                $scope.sourcesRequired = $scope.calculateSourcesRequired($scope.verification)
            });

        }
    }
});
